import {object} from "yup";
import * as Yup from "yup";



export const companyDataValidationSchema = object({
    name1: Yup.string(),
    telefon1: Yup.string(),
    name2: Yup.string(),
    email: Yup.string().email('Email ist nicht gültig. (beispiel@email.at)'),
    web: Yup.string(),
    emailERechnung: Yup.string().email('Email ist nicht gültig. (beispiel@email.at)'),
    uidnr: Yup.string(),
    firmenbuchnummer: Yup.string()
})

export type companyDataFormType = Yup.InferType<typeof companyDataValidationSchema>
